// Cowtown Sticker Co. Shopify Theme Core JS

// Accessible Order Box drawer.
let orderBoxTrigger=null,orderBoxTimer=null,orderBoxOverflow='';
function openCartDrawer(trigger) {
 const overlay=document.getElementById('CartDrawerOverlay'),box=document.getElementById('CartDrawerContainer');if(!overlay||!box)return;
 clearTimeout(orderBoxTimer);if(box.getAttribute('aria-hidden')!=='false'){orderBoxTrigger=trigger||document.activeElement;orderBoxOverflow=document.body.style.overflow;}
 overlay.classList.remove('hidden');box.inert=false;box.setAttribute('aria-hidden','false');box.classList.remove('translate-x-full');document.body.style.overflow='hidden';orderBoxTrigger?.setAttribute('aria-expanded','true');box.querySelector('button')?.focus();
}
function closeCartDrawer() {
 const overlay=document.getElementById('CartDrawerOverlay'),box=document.getElementById('CartDrawerContainer');if(!overlay||!box)return;
 box.inert=true;box.setAttribute('aria-hidden','true');box.classList.add('translate-x-full');document.body.style.overflow=orderBoxOverflow;orderBoxTrigger?.setAttribute('aria-expanded','false');orderBoxTrigger?.focus();clearTimeout(orderBoxTimer);orderBoxTimer=setTimeout(()=>overlay.classList.add('hidden'),300);
}
document.addEventListener('keydown',e=>{
 const box=document.getElementById('CartDrawerContainer');if(!box||box.getAttribute('aria-hidden')!=='false')return;
 if(e.key==='Escape'){e.preventDefault();closeCartDrawer();return;}
 if(e.key!=='Tab')return;
 const items=[...box.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex="0"]')].filter(x=>x.getClientRects().length),first=items[0],last=items.at(-1);
 if(!first){e.preventDefault();box.focus();return;}
 if(e.shiftKey&&(document.activeElement===first||!box.contains(document.activeElement))){e.preventDefault();last.focus();}
 else if(!e.shiftKey&&(document.activeElement===last||!box.contains(document.activeElement))){e.preventDefault();first.focus();}
});

// Toggle Mobile Dropdown Menu
function toggleMobileMenu() {
  const menu = document.getElementById('MobileMenu');
  if (menu) {
    menu.classList.toggle('hidden');
  }
}

// Filter Product Catalog Grid
function filterStickerProducts(category) {
  const cards = document.querySelectorAll('.product-item-card');
  const buttons = document.querySelectorAll('.catalog-tab-btn');

  buttons.forEach(btn => {
    if (btn.dataset.filter === category) {
      btn.classList.remove('bg-slate-900', 'text-slate-300', 'border-slate-800');
      btn.classList.add('bg-amber-500', 'text-slate-950');
    } else {
      btn.classList.remove('bg-amber-500', 'text-slate-950');
      btn.classList.add('bg-slate-900', 'text-slate-300', 'border-slate-800');
    }
  });

  cards.forEach(card => {
    if (category === 'all' || card.dataset.category === category) {
      card.classList.remove('hidden');
    } else {
      card.classList.add('hidden');
    }
  });
}

// Select Product from Catalog Card & Scroll to Configurator
function selectStickerProduct(productId) {
  if(window.configureFromProduct){window.configureFromProduct(productId);}
  else if (window.selectConfigProduct) {
    window.selectConfigProduct(productId);
    const catalogMaterials = { 'die-cut': 'standard', 'kiss-cut': 'standard', 'holographic': 'holographic', 'holographic-kiss-cut': 'holographic', 'bumper-decal': 'industrial', 'heavy-duty-kiss-cut': 'industrial', 'sticker-sheet': 'standard' };
    if (catalogMaterials[productId] && window.updateMaterial) window.updateMaterial(catalogMaterials[productId]);
  }
  const configurator = document.getElementById('configurator');
  if (configurator) {
    configurator.scrollIntoView({ behavior: 'smooth' });
  }
}

function navigateStickerProduct(event,productId){if(document.getElementById('configurator')&&window.selectConfigProduct){event.preventDefault();selectStickerProduct(productId);return false;}return true;}
window.navigateStickerProduct=navigateStickerProduct;

// The header's Instant Customizer link should land on the working surface,
// not above it at the section heading.
function scrollToConfiguratorWorkspace(behavior='smooth') {
  const workspace=document.querySelector('#configurator .csc-config-layout');
  const header=document.querySelector('header');
  if(!workspace)return false;
  const headerHeight=header ? header.getBoundingClientRect().height : 0;
  const destination=window.scrollY+workspace.getBoundingClientRect().top-headerHeight-12;
  window.scrollTo({top:Math.max(0,destination),behavior});
  return true;
}
document.addEventListener('click',(event)=>{
  const link=event.target.closest('a[href]');
  if(!link)return;
  let url;try{url=new URL(link.href,window.location.href);}catch(_){return;}
  if(url.hash!=='#configurator'||url.pathname!==window.location.pathname)return;
  event.preventDefault();
  history.replaceState(null,'','#configurator');
  scrollToConfiguratorWorkspace();
});
document.addEventListener('DOMContentLoaded',()=>{
  if(window.location.hash==='#configurator')requestAnimationFrame(()=>requestAnimationFrame(()=>scrollToConfiguratorWorkspace('auto')));
});
window.scrollToConfiguratorWorkspace=scrollToConfiguratorWorkspace;

// Keep the header out of the way while customers configure, then reveal it
// gently as soon as they reverse direction.
(() => {
  let lastY=window.scrollY, ticking=false, fullHeaderHeight=0;
  const header=()=>document.querySelector('.cowtown-site-header');
  const setHeader=(hidden,compact=false)=>{
    const element=header();if(!element)return;
    element.classList.toggle('is-hidden',hidden);
    element.classList.toggle('is-compact',!hidden&&compact);
  };
  const captureHeaderHeight=()=>{const element=header();if(element&&!fullHeaderHeight)fullHeaderHeight=Math.ceil(element.getBoundingClientRect().height);};
  document.addEventListener('DOMContentLoaded',captureHeaderHeight,{once:true});
  window.addEventListener('scroll',()=>{
    if(ticking)return;
    ticking=true;requestAnimationFrame(()=>{
      const y=window.scrollY, delta=y-lastY;
      captureHeaderHeight();
      if(y<=fullHeaderHeight+12)setHeader(false,false);
      else if(delta>8)setHeader(true);
      else if(delta<-4)setHeader(false,true);
      lastY=y;ticking=false;
    });
  },{passive:true});
  document.addEventListener('toggle',(event)=>{
    if(event.target.matches?.('#configurator details')&&event.target.open)setHeader(true,true);
  },true);
  document.addEventListener('change',(event)=>{
    if(event.target.closest?.('#configurator'))setHeader(true,true);
  });
})();
// Update Cart Item Quantity via Shopify Cart AJAX API
async function updateCartItemQty(lineIndex, newQty) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: newQty })
    });
    
    if (res.ok) {
      window.location.reload();
    } else {
      // Fallback reload if Shopify local dev mock
      window.location.reload();
    }
  } catch (err) {
    console.log('Cart update note:', err);
    window.location.reload();
  }
}

// Expose globally
window.openCartDrawer = openCartDrawer;
window.closeCartDrawer = closeCartDrawer;
window.toggleMobileMenu = toggleMobileMenu;
window.filterStickerProducts = filterStickerProducts;
window.selectStickerProduct = selectStickerProduct;
window.updateCartItemQty = updateCartItemQty;


// Offset anchor navigation by the actual persistent header height.
(()=>{const header=document.getElementById('shopify-section-header');if(!header)return;const measure=()=>document.documentElement.style.setProperty('--csc-header-height',(header.getBoundingClientRect().height+12)+'px');new ResizeObserver(measure).observe(header);measure();})();
